import { useEffect, useState } from 'react';
import { gsap } from 'gsap';

function useCoinFlip({ mustSpin, winner }, boxRef) {
  const [cointFlip, setCoinFlip] = useState('heads');

  useEffect(() => {
    if (mustSpin) {
      onCoinFlip();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mustSpin]);

  const onCoinFlip = () => {
    let totalFlips = winner === cointFlip ? 2 : 1;

    gsap.to(boxRef.current, {
      duration: 2,
      ease: 'power1.out',
      rotationY: '+=' + 180 * (10 + totalFlips),
      scale: 1.7,
      onComplete: () => {
        gsap.to(boxRef.current, {
          duration: 2,
          ease: 'power1.in',
          rotationY: '+=' + 180 * 10,
          scale: 1,
          onComplete: () => {
            if (winner !== cointFlip) {
              setCoinFlip(cointFlip === 'heads' ? 'tails' : 'heads');
            }
          },
        });
      },
    });
  };

  return [];
}

export default useCoinFlip;
